export default "/images/vendor/@coreui/icons/svg/flag/cif-sk.svg?578c887ff3d08dd304b7655bed2e4a35";